import includedUser from './includes/user';

const note = (noteJson) => {
  const properties = {
    ...noteJson.attributes,
    author: includedUser(noteJson.attributes.author),
    guid: noteJson.guid,
  };
  return properties;
};

export default note;
